import { Button } from "@sso/ui/Button";
import { CircleLoading } from "@sso/ui/CircleLoading";
import { Flex, FlexProps } from "@sso/ui/FlexBox";

interface SubmitLoadingButtonProps extends FlexProps {
  buttonTitle: string | JSX.Element;
  disabledButton?: boolean;
  loading?: boolean;
}
export const SubmitLoadingButton = ({
  buttonTitle,
  disabledButton,
  loading,
  ...containerProps
}: SubmitLoadingButtonProps) => {
  return (
    <Flex position="relative" width="100%" margin="0.25rem 0" {...containerProps}>
      <Button disabled={loading || disabledButton} fullWidth type="submit" padding="0.7rem 1rem" fontSize="1.25rem">
        {buttonTitle}
      </Button>
      {loading && <CircleLoading />}
    </Flex>
  );
};
